export function normalizeRef(ref: string): string {
  return ref.trim().toUpperCase().replace(/\s+/g, '');
}

